import type { UpdateOrderItemPayload } from "../types/orders";

interface OrderItemUpdateSource {
  id: number | string;
  quantity: number | string;
  price: number | string;
  discount?: number | string | null;
  tax_rate?: number | string | null;
  shipped_amount?: number | string | null;
}

export function normalizeOrderItemUpdatePayload(
  item: OrderItemUpdateSource
): UpdateOrderItemPayload {
  return {
    id: Number(item.id),
    quantity: Number(item.quantity),
    price: Number(item.price),
    discount: Number(item.discount ?? 0),
    tax_rate: Number(item.tax_rate ?? 0),
    shipped_amount: Number(item.shipped_amount ?? 0),
  };
}
